import { MessageType } from '../../types';
import React from 'react';

import Icon from '../Icon';
import './styles.css';
const senderToIcon = sender => {
	switch (sender) {
	case 'ceo':
		return 'ceo';
	case 'coo':
		return 'coo';
	case 'cfo':
		return 'cfo';
	case 'sd':
		return 'sd';
	default:
		return 'avatar';
	}
};
const InboxMessageHeader = ({ message }) => (
	<div className="inbox-message-header">
		<Icon icon={senderToIcon(message.from.avatar)} />
		<span>{message.from.fullName}</span>
	</div>
);

InboxMessageHeader.propTypes = {
	message: MessageType.isRequired
};

export default InboxMessageHeader;
